/* RY Items — Shopify Theme JS */
(function() {
  'use strict';

  // Fade-in observer (handles both .fade-in and .fade-up)
  function initFadeIn() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.fade-in, .fade-up').forEach(function(el){ el.classList.add('visible'); });
      return;
    }
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          observer.unobserve(e.target);
        }
      });
    }, { threshold: 0.08 });
    document.querySelectorAll('.fade-in, .fade-up').forEach(function(el) { observer.observe(el); });
  }

  // Mobile menu
  function initMobileMenu() {
    var toggle = document.querySelector('.mobile-menu-toggle');
    var links = document.querySelector('.nav-links');
    if (!toggle || !links) return;
    toggle.addEventListener('click', function() {
      links.classList.toggle('open');
      toggle.setAttribute('aria-expanded', links.classList.contains('open'));
    });
    // Close on link click
    links.querySelectorAll('a').forEach(function(a) {
      a.addEventListener('click', function() { links.classList.remove('open'); });
    });
  }

  // Modals (homepage product modals)
  window.openModal = function(id) {
    var m = document.getElementById('modal-' + id);
    if (m) { m.classList.add('active'); document.body.style.overflow = 'hidden'; }
  };
  window.closeModal = function(id) {
    var m = document.getElementById('modal-' + id);
    if (m) { m.classList.remove('active'); document.body.style.overflow = ''; }
  };
  function initModals() {
    document.querySelectorAll('.modal-overlay').forEach(function(m) {
      m.addEventListener('click', function(e) {
        if (e.target === m) {
          m.classList.remove('active');
          document.body.style.overflow = '';
        }
      });
    });
  }

  // Product gallery thumbnail switcher
  function initProductGallery() {
    var thumbs = document.querySelectorAll('.product-thumbnails img');
    var main = document.querySelector('.product-gallery .gallery-main');
    if (!thumbs.length || !main) return;
    thumbs.forEach(function(t) {
      t.addEventListener('click', function() {
        thumbs.forEach(function(x){ x.classList.remove('active'); });
        t.classList.add('active');
        main.src = t.getAttribute('data-full') || t.src;
      });
    });
  }

  // Quantity buttons
  function initQuantity() {
    document.querySelectorAll('[data-qty-minus]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = document.querySelector(btn.getAttribute('data-target'));
        if (input && parseInt(input.value, 10) > 1) input.value = parseInt(input.value, 10) - 1;
      });
    });
    document.querySelectorAll('[data-qty-plus]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = document.querySelector(btn.getAttribute('data-target'));
        if (input) input.value = parseInt(input.value, 10) + 1;
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    initFadeIn();
    initMobileMenu();
    initModals();
    initProductGallery();
    initQuantity();
  });
})();
